import {
    VALIDATE_LOGIN_ACCESS,
    GET_LOGIN_USER,
    GET_USER_STATUS,
    CREATE_USER,
    GET_LOGIN_HISTORY,
    RESET_PASSWORD,
} from '../actionTypes/LoginActionTypes';
const initialState={
    user:{},
    loginData: [],
    status:false
}
export const LoginReducer = (state=initialState, action) =>{
switch(action.type){
    case GET_LOGIN_USER:
        return {...state,user: action.payload}
    case GET_USER_STATUS:
        return {...state,status: action.payload}    

        case GET_LOGIN_HISTORY:
            console.log(action.payload)
            const history = [...state.loginData, ...action.payload];
            
      console.log(history)
            return {
              ...state,loginData: history,
            };
    default:
        return state;    
}
}